import {
  createApiClient,
  getHeader,
  getOrganizationId,
  handleError,
  handleResponse
} from '@/helpers/api'

const apiInboxClient = createApiClient(window.config.VUE_APP_JOBS_API_BASE_URL)

// EXPORTS
export const inboxService = {
  getInbox,
  getDocumentDetails,
  getDocumentPreview,
  getInboxesList,
  getUserInboxesList,
  createInbox,
  updateInbox,
  deleteInbox,
  getClientsToFilterList,
  assignDocumentToMe,
  assignInboxesToUser,
  setDocumentStatus,
  reassignDocumentToAnotherInbox,
  searchInbox,
  getLastImportDate,
  setInboxNote
}

// API CALLS
async function getInbox() {
  return await apiInboxClient
  .get(`/input/organization/${getOrganizationId()}`)
  .then(handleResponse)
  .catch(handleError);
}

async function getDocumentPreview(documentId) {
  return await apiInboxClient
  .get(`/input/organization/${getOrganizationId()}/document/${documentId}`, {
    headers: {
      ...getHeader().headers,
      Range: 'bytes=0-3145728' // Request the first 3MB
    },
    responseType: 'blob'
  })
  .then(handleResponse)
  .catch(handleError)
}

async function getDocumentDetails(documentId) {
  return await apiInboxClient
  .get(`/input/organization/${getOrganizationId()}/document/${documentId}`,
    getHeader({responseType: 'blob'}))
  .then(handleResponse)
  .catch(handleError)
}

async function getInboxesList() {
  return await apiInboxClient
  .get(`/input/organization/${getOrganizationId()}/inboxes`)
  .then(handleResponse)
  .catch(handleError)
}

async function getUserInboxesList() {
  return await apiInboxClient
  .get(`/input/organization/${getOrganizationId()}/inboxes/user`)
  .then(handleResponse)
  .catch(handleError)
}

async function createInbox(payload) {
  return await apiInboxClient
  .put(`/input/organization/${getOrganizationId()}/inboxes`,
    payload)
  .then(handleResponse)
  .catch(handleError)
}

async function updateInbox(inbox, newName, deletionDeadline) {
  return await apiInboxClient
  .post(`/input/organization/${getOrganizationId()}/inboxes/${inbox.id}`,
    {
      inboxName: newName,
      deletionDeadline: deletionDeadline
    })
  .then(handleResponse)
  .catch(handleError);
}

async function deleteInbox(inbox) {
  return await apiInboxClient
  .delete(`/input/organization/${getOrganizationId()}/inboxes/${inbox.id}`)
  .then(handleResponse)
  .catch(handleError)

}

async function getClientsToFilterList() {
  return await apiInboxClient
  .get(`/input/organization/${getOrganizationId()}/clients`)
  .then(handleResponse)
  .catch(handleError)
}

async function assignDocumentToMe(documentId) {
  return await apiInboxClient
  .post(`/input/document/${documentId}/assign-to-me`)
  .then(handleResponse)
  .catch(handleError)
}

async function reassignDocumentToAnotherInbox(documentId, newInboxId) {
  return await apiInboxClient
  .post(`/input/document/${documentId}/reassign-inbox`,
    {inboxId: newInboxId})
  .then(handleResponse)
  .catch(handleError)
}

async function setDocumentStatus(documentId, newStatusId) {
  return await apiInboxClient
  .post(`/input/document/${documentId}/set-status`,
    {inboxStatus: newStatusId})
  .then(handleResponse)
  .catch(handleError)
}

async function assignInboxesToUser(userId, inboxIds) {
  let payload = inboxIds.map(inboxId => {
    return {'inboxId': inboxId}
  })
  return await apiInboxClient
  .post(`/input/organization/${getOrganizationId()}/user/${userId}/set-inboxes`,
    payload)
  .then(handleResponse)
  .catch(handleError)
}

async function searchInbox(searchTerm) {
  return await apiInboxClient
  .get(`/input/organization/${getOrganizationId()}/documents/search?q=${searchTerm}`)
  .then(handleResponse)
  .catch(handleError)
}

async function getLastImportDate() {
  const organizationId = getOrganizationId() || null
  return await apiInboxClient
    .get(`/input/organization/${organizationId}/last-import`, getHeader())
    .then(handleResponse)
    .catch(handleError)
}

async function setInboxNote(id, newInboxNote) {
  return await apiInboxClient
    .put(`/input/document/${id}/note`,
      {note: newInboxNote})
    .then(handleResponse)
    .catch(handleError)
}
